


/**
 * 
 * Usage:
 * import safeStringify from './utils/safe-stringify';
 * 
 * console.log(`someFunction(): obj = ${safeStringify(obj, 2)}`);
 * 
 * @param {*} obj 
 * @param {*} depth 
 * @returns 
 */
function safeStringify(obj, depth = 2, excludeKeys = []) {
  const cache = new WeakSet();

  return JSON.stringify(
    obj,
    (key, value) => {
      // Skip excluded keys
      if (excludeKeys.includes(key)) return undefined;

      // Handle circular references
      if (typeof value === "object" && value !== null) {
        if (cache.has(value)) return "[Circular]";
        cache.add(value);
      }

      return value;
    },
    depth
  );
}
export default safeStringify;
